import { WholesalerCatalog } from './WholesalerCatalog'
import { Grid, Paper } from '@mui/material'

const WholesalerCatalogContainer = () => {
  return (
    <Paper sx={{ p: 2 }} data-testid='wholesaler-catalog-container'>
      <Grid container direction='row' spacing={2}>
        <Grid item xs={12}>
          <WholesalerCatalog />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default WholesalerCatalogContainer
